import { FRANCHISE_STORE } from "../../../../types.js";
import { convertToValidOpeningHours } from "../../../adapters/pages/adapters/convert-to-valid-opening-hours.js";
import { getRating } from "../../../adapters/pages/adapters/get-rating.js";
const fromStoreGroupQueryDataToStores = (storeGroupQueryData) => {
  if (!storeGroupQueryData) {
    return null;
  }
  try {
    return storeGroupQueryData.map(fromStoreGroupEntryToStore);
  } catch (e) {
    console.error(
      "Store group query data adapter failed to parse input data correctly.",
      e,
      storeGroupQueryData
    );
    return null;
  }
};
const fromStoreGroupEntryToStore = (entry) => {
  const franchiseStory = entry.storeTypes || [];
  return {
    code: entry.code,
    globalStoreId: entry.globalStoreId,
    name: entry.name,
    shortName: entry.name,
    streetName: entry.streetName,
    town: entry.town,
    country: entry.country,
    rating: getRating(entry.rating ?? void 0),
    phone: entry.phone,
    slug: entry.slug ?? void 0,
    storeNote: entry.storenote ?? void 0,
    streetNumber: entry.streetNumber ?? void 0,
    additionalStreetInfo: entry.additionalStreetInfo ?? void 0,
    postalCode: entry.postalCode ?? void 0,
    province: entry.province ?? void 0,
    lat: entry.lat ?? void 0,
    lon: entry.lon ?? void 0,
    emailAddress: entry.email ?? void 0,
    servicesNotAvailable: entry.servicesNotAvailable ?? [],
    appointmentsAvailable: entry.appointmentsAvailable,
    openingHours: {
      monday: convertToValidOpeningHours(entry.monOpenClose),
      tuesday: convertToValidOpeningHours(entry.tueOpenClose),
      wednesday: convertToValidOpeningHours(entry.wedOpenClose),
      thursday: convertToValidOpeningHours(entry.thuOpenClose),
      friday: convertToValidOpeningHours(entry.friOpenClose),
      saturday: convertToValidOpeningHours(entry.satOpenClose),
      sunday: convertToValidOpeningHours(entry.sunOpenClose)
    },
    specialOpeningHours: (entry.specialOpenClosingHours ?? []).filter(
      (entry2) => entry2 !== null
    ),
    storeDetailImage: entry.storeDetailImage ?? void 0,
    wheelchairAccessible: entry.wheelchairAccessible ?? void 0,
    weekendOpen: entry.weekendOpen ?? false,
    hearingAppointmentPossible: entry.hearingAppointmentPossible ?? false,
    isFranchiseStore: franchiseStory.includes(FRANCHISE_STORE)
  };
};
export {
  fromStoreGroupEntryToStore,
  fromStoreGroupQueryDataToStores
};
//# sourceMappingURL=adapters.js.map
